import React from "react";
import {
  useTranslate,
  List,
  Create,
  TextInput,
  Edit,
  SimpleForm,
  TextField,
  useListContext,
  EditButton,
  SelectInput,
  useRedirect,
} from "react-admin";
import {
  Container,
  Content,
  HeaderRow,
  Title,
  Actions,
  CreateActionButton,
  TableCard,
  FormCard,
  TableHeader,
  HeaderCell,
  TableBody,
  AddressRow,
  Cell,
  FieldValue,
  RowActions,
} from "./styles";

const countryChoices = [

            { id: "África do Sul", name: "África do Sul" },
            { id: "Albânia", name: "Albânia" },
            { id: "Alemanha", name: "Alemanha" },
            { id: "Andorra", name: "Andorra" },
            { id: "Angola", name: "Angola" },
            { id: "Anguilla", name: "Anguilla" },
            { id: "Antigua", name: "Antigua" },
            { id: "Arábia Saudita", name: "Arábia Saudita" },
            { id: "Argentina", name: "Argentina" },
            { id: "Armênia", name: "Armênia" },
            { id: "Aruba", name: "Aruba" },
            { id: "Austrália", name: "Austrália" },
            { id: "Áustria", name: "Áustria" },
            { id: "Azerbaijão", name: "Azerbaijão" },
            { id: "Bahamas", name: "Bahamas" },
            { id: "Bahrein", name: "Bahrein" },
            { id: "Bangladesh", name: "Bangladesh" },
            { id: "Barbados", name: "Barbados" },
            { id: "Bélgica", name: "Bélgica" },
            { id: "Benin", name: "Benin" },
            { id: "Bermudas", name: "Bermudas" },
            { id: "Botsuana", name: "Botsuana" },
            { id: "Brasil", name: "Brasil" },
            { id: "Brunei", name: "Brunei" },
            { id: "Bulgária", name: "Bulgária" },
            { id: "Burkina Fasso", name: "Burkina Fasso" },
            { id: "botão", name: "botão" },
            { id: "Cabo Verde", name: "Cabo Verde" },
            { id: "Camarões", name: "Camarões" },
            { id: "Camboja", name: "Camboja" },
            { id: "Canadá", name: "Canadá" },
            { id: "Cazaquistão", name: "Cazaquistão" },
            { id: "Chade", name: "Chade" },
            { id: "Chile", name: "Chile" },
            { id: "China", name: "China" },
            { id: "Cidade do Vaticano", name: "Cidade do Vaticano" },
            { id: "Colômbia", name: "Colômbia" },
            { id: "Congo", name: "Congo" },
            { id: "Coréia do Sul", name: "Coréia do Sul" },
            { id: "Costa do Marfim", name: "Costa do Marfim" },
            { id: "Costa Rica", name: "Costa Rica" },
            { id: "Croácia", name: "Croácia" },
            { id: "Dinamarca", name: "Dinamarca" },
            { id: "Djibuti", name: "Djibuti" },
            { id: "Dominica", name: "Dominica" },
            { id: "EUA", name: "EUA" },
            { id: "Egito", name: "Egito" },
            { id: "El Salvador", name: "El Salvador" },
            { id: "Emirados Árabes", name: "Emirados Árabes" },
            { id: "Equador", name: "Equador" },
            { id: "Eritréia", name: "Eritréia" },
            { id: "Escócia", name: "Escócia" },
            { id: "Eslováquia", name: "Eslováquia" },
            { id: "Eslovênia", name: "Eslovênia" },
            { id: "Espanha", name: "Espanha" },
            { id: "Estônia", name: "Estônia" },
            { id: "Etiópia", name: "Etiópia" },
            { id: "Fiji", name: "Fiji" },
            { id: "Filipinas", name: "Filipinas" },
            { id: "Finlândia", name: "Finlândia" },
            { id: "França", name: "França" },
            { id: "Gabão", name: "Gabão" },
            { id: "Gâmbia", name: "Gâmbia" },
            { id: "Gana", name: "Gana" },
            { id: "Geórgia", name: "Geórgia" },
            { id: "Gibraltar", name: "Gibraltar" },
            { id: "Granada", name: "Granada" },
            { id: "Grécia", name: "Grécia" },
            { id: "Guadalupe", name: "Guadalupe" },
            { id: "Guam", name: "Guam" },
            { id: "Guatemala", name: "Guatemala" },
            { id: "Guiana", name: "Guiana" },
            { id: "Guiana Francesa", name: "Guiana Francesa" },
            { id: "Guiné-bissau", name: "Guiné-bissau" },
            { id: "Haiti", name: "Haiti" },
            { id: "Holanda", name: "Holanda" },
            { id: "Honduras", name: "Honduras" },
            { id: "Hong Kong", name: "Hong Kong" },
            { id: "Hungria", name: "Hungria" },
            { id: "Iêmen", name: "Iêmen" },
            { id: "Ilhas Cayman", name: "Ilhas Cayman" },
            { id: "Ilhas Cook", name: "Ilhas Cook" },
            { id: "Ilhas Curaçao", name: "Ilhas Curaçao" },
            { id: "Ilhas Marshall", name: "Ilhas Marshall" },
            { id: "Ilhas Turks & Caicos", name: "Ilhas Turks & Caicos" },
            { id: "Ilhas Virgens (brit.)", name: "Ilhas Virgens (brit.)" },
            { id: "Ilhas Virgens(amer.)", name: "Ilhas Virgens(amer.)" },
            { id: "Ilhas Wallis e Futuna", name: "Ilhas Wallis e Futuna" },
            { id: "Índia", name: "Índia" },
            { id: "Indonésia", name: "Indonésia" },
            { id: "Inglaterra", name: "Inglaterra" },
            { id: "Irlanda", name: "Irlanda" },
            { id: "Islândia", name: "Islândia" },
            { id: "Israel", name: "Israel" },
            { id: "Itália", name: "Itália" },
            { id: "Jamaica", name: "Jamaica" },
            { id: "Japão", name: "Japão" },
            { id: "Jordânia", name: "Jordânia" },
            { id: "Kuwait", name: "Kuwait" },
            { id: "Latvia", name: "Latvia" },
            { id: "Líbano", name: "Líbano" },
            { id: "Liechtenstein", name: "Liechtenstein" },
            { id: "Lituânia", name: "Lituânia" },
            { id: "Luxemburgo", name: "Luxemburgo" },
            { id: "Macau", name: "Macau" },
            { id: "Macedônia", name: "Macedônia" },
            { id: "Madagascar", name: "Madagascar" },
            { id: "Malásia", name: "Malásia" },
            { id: "Malaui", name: "Malaui" },
            { id: "Mali", name: "Mali" },
            { id: "Malta", name: "Malta" },
            { id: "Marrocos", name: "Marrocos" },
            { id: "Martinica", name: "Martinica" },
            { id: "Mauritânia", name: "Mauritânia" },
            { id: "Mauritius", name: "Mauritius" },
            { id: "México", name: "México" },
            { id: "Moldova", name: "Moldova" },
            { id: "Mônaco", name: "Mônaco" },
            { id: "Moçambique", name: "Moçambique" },
            { id: "Montserrat", name: "Montserrat" },
            { id: "Nepal", name: "Nepal" },
            { id: "Nicarágua", name: "Nicarágua" },
            { id: "Niger", name: "Niger" },
            { id: "Nigéria", name: "Nigéria" },
            { id: "Noruega", name: "Noruega" },
            { id: "Nova Caledônia", name: "Nova Caledônia" },
            { id: "Nova Zelândia", name: "Nova Zelândia" },
            { id: "Omã", name: "Omã" },
            { id: "Palau", name: "Palau" },
            { id: "Panamá", name: "Panamá" },
            { id: "Papua-nova Guiné", name: "Papua-nova Guiné" },
            { id: "Paquistão", name: "Paquistão" },
            { id: "Peru", name: "Peru" },
            { id: "Polinésia Francesa", name: "Polinésia Francesa" },
            { id: "Polônia", name: "Polônia" },
            { id: "Porto Rico", name: "Porto Rico" },
            { id: "Portugal", name: "Portugal" },
            { id: "Qatar", name: "Qatar" },
            { id: "Quênia", name: "Quênia" },
            { id: "Rep. Dominicana", name: "Rep. Dominicana" },
            { id: "Rep. Tcheca", name: "Rep. Tcheca" },
            { id: "Reunion", name: "Reunion" },
            { id: "Romênia", name: "Romênia" },
            { id: "Ruanda", name: "Ruanda" },
            { id: "Rússia", name: "Rússia" },
            { id: "Saipan", name: "Saipan" },
            { id: "Samoa Americana", name: "Samoa Americana" },
            { id: "Senegal", name: "Senegal" },
            { id: "Serra Leone", name: "Serra Leone" },
            { id: "Seychelles", name: "Seychelles" },
            { id: "Singapura", name: "Singapura" },
            { id: "Síria", name: "Síria" },
            { id: "Sri Lanka", name: "Sri Lanka" },
            { id: "St. Kitts & Nevis", name: "St. Kitts & Nevis" },
            { id: "St. Lúcia", name: "St. Lúcia" },
            { id: "St. Vincent", name: "St. Vincent" },
            { id: "Sudão", name: "Sudão" },
            { id: "Suécia", name: "Suécia" },
            { id: "Suiça", name: "Suiça" },
            { id: "Suriname", name: "Suriname" },
            { id: "Tailândia", name: "Tailândia" },
            { id: "Taiwan", name: "Taiwan" },
            { id: "Tanzânia", name: "Tanzânia" },
            { id: "Togo", name: "Togo" },
            { id: "Trinidad & Tobago", name: "Trinidad & Tobago" },
            { id: "Tunísia", name: "Tunísia" },
            { id: "Turquia", name: "Turquia" },
            { id: "Ucrânia", name: "Ucrânia" },
            { id: "Uganda", name: "Uganda" },
            { id: "Uruguai", name: "Uruguai" },
            { id: "Venezuela", name: "Venezuela" },
            { id: "Vietnã", name: "Vietnã" },
            { id: "Zaire", name: "Zaire" },
            { id: "Zâmbia", name: "Zâmbia" },
            { id: "Zimbábue", name: "Zimbábue" },
                
];

const AddressListContent = () => {
  const translate = useTranslate();
  const { basePath, total, ids = [], data = {}, loaded } = useListContext();

  return (
    <Container>
      <Content>
        <HeaderRow>
          <Title>Endereços</Title>
          <Actions>
            <CreateActionButton basePath={basePath}>
              + Novo
            </CreateActionButton>
          </Actions>
        </HeaderRow>
        <TableCard>
          {!loaded ? (
            <p>Carregando...</p>
          ) : ids.length === 0 ? (
            <p>Nenhum endereço cadastrado</p>
          ) : (
            <>
              <TableHeader>
                <HeaderCell>
                  {translate("custom.entities.address.street")}
                </HeaderCell>
                <HeaderCell>
                  {translate("custom.entities.address.city")}
                </HeaderCell>
                <HeaderCell>
                  {translate("custom.entities.address.state")}
                </HeaderCell>
                <HeaderCell>
                  {translate("custom.entities.address.country")}
                </HeaderCell>
                <HeaderCell>
                  {translate("custom.entities.address.zipcode")}
                </HeaderCell>
                <HeaderCell>{" "}</HeaderCell>
              </TableHeader>
              <TableBody>
                {ids.map((id) => {
                  const record = data[id];
                  if (!record) return null;
                  return (
                    <AddressRow key={id}>
                      <Cell>
                        <FieldValue>{record.street}</FieldValue>
                      </Cell>
                      <Cell>
                        <FieldValue>{record.city}</FieldValue>
                      </Cell>
                      <Cell>
                        <FieldValue>{record.state}</FieldValue>
                      </Cell>
                      <Cell>
                        <FieldValue>{record.country}</FieldValue>
                      </Cell>
                      <Cell>
                        <FieldValue>{record.zipCode}</FieldValue>
                      </Cell>
                      <RowActions>
                        <EditButton
                          record={record}
                          basePath={basePath}
                          label={translate("ra.action.edit")}
                        />
                      </RowActions>
                    </AddressRow>
                  );
                })}
              </TableBody>
            </>
          )}
        </TableCard>
      </Content>
    </Container>
  );
};

export const AddressList = (props: any) => {
  const translate = useTranslate();
  return (
    <List
      {...props}
      title={translate(`custom.menu.${props.resource}`)}
      exporter={false}
      bulkActionButtons={false}
      pagination={false}
      actions={false}
    >
      <AddressListContent />
    </List>
  );
};

const validateAddress = (values: any) => {
  const errors: any = {};
  //console.log()
  if (!values.street) {
    errors.street = ["A rua é obrigatória!"];
  }

  if (!values.city) {
    errors.city = ["A cidade é obrigatória!"];
  }

  if (!values.country) {
    errors.country = ["O país é obrigatório!"];
  }

  return errors;
};

export const AddressEdit = (props: any) => {
  const translate = useTranslate();

  return (
    <Edit
      undoable={false}
      {...props}
      title={translate(`custom.menu.${props.resource}`)}
    >
      <SimpleForm validate={validateAddress}>
        <Container>
          <Content>
            <HeaderRow>
              <Title>Endereço</Title>
            </HeaderRow>
            <FormCard>
              <TextInput
                source="street"
                label={translate("custom.entities.address.street")}
                fullWidth={true}
              />
              <TextInput
                source="city"
                label={translate("custom.entities.address.city")}
                fullWidth={true}
              />
              <TextInput
                source="state"
                label={translate("custom.entities.address.state")}
                fullWidth={true}
              />

              <SelectInput
                label="País"
                source="country"
                defaultValue={"Brasil"}
                choices={countryChoices}
                fullWidth={true}
              />

              <TextInput
                source="zipCode"
                label={translate("custom.entities.address.zipcode")}
                fullWidth={true}
              />
            </FormCard>
          </Content>
        </Container>
      </SimpleForm>
    </Edit>
  );
};

export const AddressCreate = (props: any) => {
  const translate = useTranslate();
  const redirect = useRedirect();

  return (
    <Create
      undoable={false}
      {...props}
      title={translate(`custom.menu.${props.resource}`)}
      onSuccess={() => {
        redirect("/address");
      }}
    >
      <SimpleForm validate={validateAddress}>
        <Container>
          <Content>
            <HeaderRow>
              <Title>Endereço</Title>
            </HeaderRow>
            <FormCard>
              <TextInput
                source="street"
                label={translate("custom.entities.address.street")}
                fullWidth={true}
              />
              <TextInput
                source="city"
                label={translate("custom.entities.address.city")}
                fullWidth={true}
              />
              <TextInput
                source="state"
                label={translate("custom.entities.address.state")}
                fullWidth={true}
              />
              <SelectInput
                label="País"
                source="country"
                defaultValue={"Brasil"}
                choices={countryChoices}
                fullWidth={true}
              />
              <TextInput
                source="zipCode"
                label={translate("custom.entities.address.zipcode")}
                fullWidth={true}
              />
            </FormCard>
          </Content>
        </Container>
      </SimpleForm>
    </Create>
  );
};
